import { Fancybox } from "@fancyapps/ui";

const farmContainer = document.querySelector('#digital-farm')
const mainViewButtons = document.querySelectorAll('.hotspot--mainview') as NodeListOf<HTMLButtonElement>
const detailViews = document.querySelectorAll('.farm__container--detailview') as NodeListOf<HTMLDivElement>
const backButtons = document.querySelectorAll('.farm__control--back') as NodeListOf<HTMLButtonElement>
const toggleFullscreenButtons = document.querySelectorAll('.farm__control--fullscreen') as NodeListOf<HTMLButtonElement>
const materialLinksContainer = document.querySelector('.farm__controls--bottom__left') as HTMLUListElement

Fancybox.bind("[farm-fancybox]", {
    parentEl: farmContainer,
    height: 'auto',
    autoFocus: false,
    hideScrollbar: false,
    on: {
        done: (fancybox) => {
            quizCloseButton(fancybox)
            addIframeEscapeListener(fancybox)

            if (fancybox.items[0] && fancybox.items[0].$trigger) {
                let closeLabel = fancybox.items[0].$trigger.getAttribute('hotspot-close-label')
                let labelContainer = document.querySelector('.farm-fancybox__close-btn--label') as HTMLSpanElement

                if (labelContainer) labelContainer.innerText = 'Stäng ' + closeLabel
            }
        }
    },
    template: {
        closeButton: `
            <button type="button" class="farm-fancybox__close-btn" data-fancybox-close aria-label="Stäng">
                <span class="farm-fancybox__close-btn--icon" aria-hidden="true"></span>
                <span class="farm-fancybox__close-btn--label"></span>
            </button>
        `,    
    },
    mainClass: 'farm-fancybox__container'
})

const hideViews = (views: NodeListOf<HTMLDivElement>) => {
    views.forEach(view => {
        view.setAttribute('view-visible', 'false')
        
        let viewLinks = document.querySelectorAll('.farm__control--material--detailview')
        if (materialLinksContainer && viewLinks.length > 0) {
            viewLinks.forEach(link => {
                let linkContainer = link.closest('li')
                materialLinksContainer.removeChild(linkContainer)
            })
        }
    })
}

const showView = (view: HTMLDivElement) => {
    view.setAttribute('view-visible', 'true')
    farmContainer.setAttribute('is-mainview', 'false')
    
    // Get material links, populate material links container
    let viewLinks = view.querySelectorAll('.farm__control--material') as NodeListOf<HTMLLinkElement>
    
    if (materialLinksContainer && viewLinks.length > 0) {
        viewLinks.forEach(link => {
            let linkClone = link.cloneNode(true) as HTMLLinkElement
            linkClone.classList.add('farm__control--material--detailview')
            let li = document.createElement('li')
            li.appendChild(linkClone)
            materialLinksContainer.appendChild(li)
        })
    }
}

const initMainViewButtons = () => {
    if (mainViewButtons) {
        mainViewButtons.forEach(button => {
            button.addEventListener('click', () => {
                let viewName = button.getAttribute('button-for')
                let view = document.querySelector('[view-for="' + viewName + '"]') as HTMLDivElement
    
                if (view) {
                    hideViews(detailViews)
                    showView(view)
                }
            })
        })
    }
}

const initControlButtons = () => {
    initToggleFullscreen()

    if (backButtons.length > 0) {
        backButtons.forEach(backButton => {
            backButton.addEventListener('click', () => {
                hideViews(detailViews)
                farmContainer.setAttribute('is-mainview', 'true')
            })
        })
    }
}

const initToggleFullscreen = () => {
    const body = document.querySelector('body')
    const farmContainer = document.querySelector('#digital-farm')

    toggleFullscreenButtons.forEach(toggleFullscreen => {
        toggleFullscreen.addEventListener('click', () => {
            if (document.fullscreenElement) {
                document.exitFullscreen()
                farmContainer.setAttribute('is-fullscreen', 'false')
            }
            else {
                if (body.requestFullscreen) {
                    body.requestFullscreen()
                    farmContainer.setAttribute('is-fullscreen', 'true')
                }
            }
        })
    })
}

// QUIZ - add listener to close button after quiz
const quizCloseButton = (fancybox: any) => {
    let iframe = document.querySelector('iframe')

    if (iframe && iframe.src.includes(document.location.host)) {
        if (iframe.contentWindow.document.body) {        
            let iframeBody = iframe.contentWindow.document.body

            if (iframeBody.id == 'PageQuiz') {
                let closeButtons = iframeBody.querySelectorAll('.close-quiz-frame') as NodeListOf<HTMLButtonElement>

                closeButtons.forEach(button => {
                    button.addEventListener('click', () => { fancybox.close() })
                })
            }
        }
    }
}

// Escape listener - close iframe fancybox on escape
const addIframeEscapeListener = (fancybox: any) => {
    let iframe = document.querySelector('iframe.fancybox__iframe') as HTMLIFrameElement

    if (iframe && iframe.src.includes(document.location.host)) {
        if (iframe.contentWindow.document.body) {   
            let iframeBody = iframe.contentWindow.document

            iframeBody.addEventListener('keydown', (e: KeyboardEvent) => {
                if (e.key == "Escape") {
                    fancybox.close()
                }
            })
        }
    }

    else if (iframe) {
        document.addEventListener('keydown', (e: KeyboardEvent) => {
            if (e.key == "Escape" || e.key == "escape") {
                e.stopPropagation()
                fancybox.close()
            }
        })
    }
}

// Onload remove loading screen
const initOnload = () => {
    if (farmContainer) {
        setTimeout(() => {
            if (document.querySelector('.farm__loading')) {
                farmContainer.removeChild(document.querySelector('.farm__loading'))
            }
        }, 2000)

        farmContainer.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
            inline:'center'
        })
    } 
}

export function initFarm() {
    initMainViewButtons()
    initControlButtons()
    initOnload()

    document.addEventListener('keydown', (e: KeyboardEvent) => {
        const fancyboxOpen = document.querySelector('iframe.fancybox__iframe') != null
        
        if (fancyboxOpen && e.key == 'Escape') {
            e.preventDefault()
        }
    })
}